export const crmMenu = [
  { id: "home", name: "Anasayfa" },
  {
    id: "admin",
    name: "Yönetim",
    children: [
      { id: "users", name: "Kullanıcılar" },
      { id: "user-groups", name: "Kullanıcı grupları" },
      { id: "roles", name: "Roller" },
      { id: "permissions", name: "Yetki matrisi" },
      { id: "company", name: "Şirket bilgileri" },
      { id: "branches", name: "Şubeler" },
      { id: "periods", name: "Mali dönemler" },
      { id: "doc-no", name: "Belge numaraları" },
      { id: "audit", name: "Sistem günlüğü" },
    ],
  },
  {
    id: "accounts",
    name: "Cari Hesaplar",
    badge: "128",
    children: [
      { id: "customers", name: "Müşteri kartları", badge: "86" },
      { id: "vendors-acc", name: "Tedarikçi kartları", badge: "42" },
      { id: "contacts", name: "Yetkili kişiler" },
      { id: "acc-moves", name: "Cari hareketler" },
      { id: "balances", name: "Cari bakiyeler" },
      { id: "aging", name: "Yaşlandırma" },
      { id: "risk", name: "Risk limitleri" },
      { id: "price-lists", name: "Fiyat listeleri" },
      { id: "agreements", name: "Cari sözleşmeler" },
    ],
  },
  {
    id: "sales",
    name: "Satış",
    badge: "24",
    children: [
      { id: "opps", name: "Satış fırsatları", badge: "24" },
      { id: "quotes", name: "Teklifler", badge: "18" },
      { id: "quote-rev", name: "Teklif revizyonları" },
      { id: "orders", name: "Satış siparişleri", badge: "11" },
      { id: "deliveries", name: "İrsaliyeler" },
      { id: "invoices", name: "Satış faturaları" },
      { id: "returns", name: "Satış iadeleri" },
      { id: "pos", name: "Hızlı satış" },
      { id: "targets", name: "Satış hedefleri" },
      { id: "commission", name: "Prim / komisyon" },
    ],
  },
  {
    id: "purchase",
    name: "Satın Alma",
    children: [
      { id: "pr", name: "Satınalma talepleri", badge: "7" },
      { id: "rfq", name: "Teklif istekleri" },
      { id: "po", name: "Satınalma siparişleri" },
      { id: "goods-in", name: "Mal kabul" },
      { id: "purchase-inv", name: "Alış faturaları" },
      { id: "purchase-ret", name: "Alış iadeleri" },
      { id: "vendors", name: "Tedarikçi değerlendirme" },
      { id: "contracts", name: "Alım sözleşmeleri" },
    ],
  },
  {
    id: "stock",
    name: "Stok",
    children: [
      { id: "items", name: "Stok kartları" },
      { id: "item-groups", name: "Stok grupları" },
      { id: "units", name: "Birimler" },
      { id: "warehouses", name: "Depolar" },
      { id: "bins", name: "Raf / lokasyon" },
      { id: "transfer", name: "Depo transfer" },
      { id: "count", name: "Stok sayımı" },
      { id: "moves", name: "Stok hareketleri" },
      { id: "lot", name: "Lot / seri no" },
      { id: "critical", name: "Kritik stok", badge: "6" },
    ],
  },
  {
    id: "production",
    name: "Üretim",
    children: [
      { id: "bom", name: "Ürün reçeteleri" },
      { id: "routings", name: "Rotalar" },
      { id: "mrp", name: "Üretim planı (MRP)" },
      { id: "jobs", name: "İş emirleri", badge: "9" },
      { id: "shopfloor", name: "Atölye ekranı" },
      { id: "ops", name: "Operasyonlar" },
      { id: "scrap", name: "Fire / fire nedenleri" },
      { id: "qc", name: "Kalite kontrol" },
      { id: "capacity", name: "Kapasite planı" },
    ],
  },
  {
    id: "service",
    name: "Destek / Servis",
    badge: "9",
    children: [
      { id: "tickets", name: "Servis talepleri", badge: "9" },
      { id: "sla", name: "SLA tanımları" },
      { id: "assign", name: "Atama kuralları" },
      { id: "field", name: "Saha servisi" },
      { id: "spare", name: "Yedek parça" },
      { id: "kb", name: "Bilgi bankası" },
      { id: "csat", name: "Müşteri memnuniyeti" },
    ],
  },
  {
    id: "finance",
    name: "Finans",
    children: [
      { id: "cash", name: "Kasa" },
      { id: "bank", name: "Banka" },
      { id: "cheques", name: "Çek / senet" },
      { id: "payments", name: "Ödeme emirleri" },
      { id: "receipts", name: "Tahsilat fişleri" },
      { id: "journal", name: "Mahsup fişi" },
      { id: "vat", name: "KDV listeleri" },
      { id: "recon", name: "Mutabakat" },
      { id: "ebills", name: "e-Fatura / e-Arşiv" },
    ],
  },
  {
    id: "hr",
    name: "İnsan Kaynakları",
    children: [
      { id: "staff", name: "Personel kartları" },
      { id: "org", name: "Organizasyon şeması" },
      { id: "shift", name: "Vardiya" },
      { id: "timesheet", name: "Puantaj" },
      { id: "leave", name: "İzinler" },
      { id: "advance", name: "Avans" },
      { id: "payroll", name: "Bordro" },
      { id: "expense", name: "Masraf formları" },
    ],
  },
  {
    id: "marketing",
    name: "Pazarlama",
    children: [
      { id: "leads", name: "Lead kayıtları" },
      { id: "campaigns", name: "Kampanyalar" },
      { id: "email", name: "E-posta şablonları" },
      { id: "sources", name: "Fırsat kaynakları" },
      { id: "segments", name: "Müşteri segmentleri" },
    ],
  },
  {
    id: "reports",
    name: "Raporlar",
    children: [
      { id: "rep-dash", name: "Yönetici özeti" },
      { id: "rep-sales", name: "Satış raporları" },
      { id: "rep-purchase", name: "Satınalma raporları" },
      { id: "rep-stock", name: "Stok raporları" },
      { id: "rep-prod", name: "Üretim raporları" },
      { id: "rep-fin", name: "Finans raporları" },
      { id: "rep-service", name: "Servis raporları" },
      { id: "rep-hr", name: "İK raporları" },
    ],
  },
  {
    id: "settings",
    name: "Ayarlar",
    children: [
      { id: "set-general", name: "Genel parametreler" },
      { id: "set-tax", name: "Vergi / tevkifat" },
      { id: "set-print", name: "Yazdırma şablonları" },
      { id: "set-int", name: "Entegrasyonlar" },
      { id: "set-notify", name: "Bildirimler" },
      { id: "set-backup", name: "Yedekleme" },
    ],
  },
];

export const dashboardKpis = [
  { label: "Açık teklif", value: "18", delta: "₺846B pipeline", up: true },
  { label: "Bekleyen sipariş", value: "11", delta: "3 teslim bugün", up: true },
  { label: "Üretimdeki iş", value: "9", delta: "%72 tamamlandı", up: true },
  { label: "Açık destek", value: "9", delta: "2 SLA riski", up: false },
];

export const dashboardDocs = [
  { no: "T-1042", type: "Teklif", party: "Anadolu Makine", amount: "84.000₺", status: "open", statusLabel: "Onay bekler" },
  { no: "S-2201", type: "Sipariş", party: "Ege Lojistik", amount: "210.000₺", status: "won", statusLabel: "Hazır" },
  { no: "IE-77", type: "İş emri", party: "Güç ünitesi 24V", amount: "12 adet", status: "open", statusLabel: "Üretimde" },
  { no: "ST-441", type: "Satınalma", party: "Bağlantı elemanı", amount: "240 adet", status: "wait", statusLabel: "Onayda" },
  { no: "#1044", type: "Destek", party: "Fatura PDF", amount: "Yüksek", status: "risk", statusLabel: "SLA" },
];
